const query = window.matchMedia( '(prefers-reduced-motion: no-preference)' );

export function prefersReducedMotion(): boolean {
	return !query.matches;
}
